<template>
  <div>
    <div
      class="qt-shadow-box accordion-box"
      v-for="(employee, index) in employees"
      :key="index"
      :class="{ active: employee.expanded }"
    >
      <div class="accordion-header">
        <h4 class="qt-project-head ">{{ employee.employeeName }} <span ></span></h4>
      </div>
      <div class="accordion-content" :style="{ maxHeight: employee.expanded ? contentHeight + 'px' : '0' }" ref="content">
        <div class="qt-full-table scrollable-table">
          <table>
            <tr>
              <th>Position Name</th>
              <th>Project Name</th>
              <th>Project Type</th>
              <th>Project Time Forcast</th>
              <th>Time recordings</th>
              <th>Time Spent %</th>
              <th>Available Time</th>
              <th>Time Release Status</th>
            </tr>
            <tr v-for="(data, dataIndex) in employee.emoloyeeData" :key="dataIndex">
              <td>{{ data.positionName }}</td>
              <td>{{ data.projectName }}</td>
              <td>{{ data.projectType }}</td>
              <td>{{ (data.projectTimeForecast ||0).toFixed(2) }} hrs</td>
              <td>{{ (data.timeRecordings || 0).toFixed(2) }} hrs</td>
              <td>{{ (data.timeSpent || 0).toFixed(2) }} %</td>
              <td>{{ (data.availableTime || 0).toFixed(2) }} hrs</td>
              <td :class="{'qt-red-text': data.status === 'Open', 'qt-green-text': data.status !== 'Open'}">{{ data.status === 'Open'? 'Not released' : data.status }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="no-item" v-if="employees.length < 1">No items found !</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      employees: [],
      contentHeight: 0,
    };
  },
  methods: {
    toggleAccordions(){
      debugger
      console.log("clicked toggle")
    setTimeout(function(){
      const accordionItems = document.querySelectorAll('.accordion-box');

  // Add click event listener to each accordion header
  accordionItems.forEach((item, index) => {
  const header = item.querySelector('.accordion-header');
  const content = item.querySelector('.accordion-content');
  header.addEventListener('click', () => {
      // Check if the clicked section is already active
      const isActive = item.classList.contains('active');

      // Open the clicked section if it wasn't active

      if (!isActive) {

          item.classList.add('active');

          content.style.maxHeight = content.scrollHeight + 'px';

      } else {

          item.classList.remove('active');

          content.style.maxHeight = null;

      }

  });
  // Open the first accordion item by default
  // if (index === 0) {
  //     item.classList.add('active');
  //     content.style.maxHeight = content.scrollHeight + 'px';
  // }
  });
    }, 1000)
   
  }
  },
  updated(){
  this.toggleAccordions();
},
  beforeMount(){
    this.$store.dispatch("DirectManagerDashboardOverview").then(() => {
    // Retrieve the fetched data from the store
    this.employees = this.directManagerDashboardOverview;

    this.employees.forEach((employee) => {
      employee.expanded = false;
    });
  });
  },
  computed: {
      directManagerDashboardOverview: function () {
              return this.$store.state.qtimeReports.directManagerDashboardOverview;
          }
  }
};
</script>
